import React from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import { Box, Button, CircularProgress, Paper, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import invoiceCustomersReportQuery from "../graphql/queries/invoiceCustomersReport";

export default function Reports() {
  const { enqueueSnackbar } = useSnackbar();
  const [loadReport, { loading }] = useLazyQuery(invoiceCustomersReportQuery, {
    fetchPolicy: "network-only",
    onCompleted: ({ invoiceCustomersReport }) => {
      const bytes = Uint8Array.from(atob(invoiceCustomersReport.contentBase64), (character) => character.charCodeAt(0));
      const url = URL.createObjectURL(new Blob([bytes], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = invoiceCustomersReport.fileName;
      link.click();
      URL.revokeObjectURL(url);
      enqueueSnackbar(`${invoiceCustomersReport.totalCount} Kunden exportiert`, { variant: "success" });
    },
    onError: (error) => enqueueSnackbar(error.message, { variant: "error" })
  });
  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>Reports</Typography>
      <Paper>
        <Box p={3}>
          <Typography variant="subtitle1">Vertriebs-Kunden mit Rechnungskauf</Typography>
          <Typography color="textSecondary" gutterBottom>Alle Vertriebs-Kunden mit Freigabe fuer Rechnungskauf.</Typography>
          <Button color="primary" disabled={loading} onClick={() => loadReport()} variant="contained">
            {loading ? <CircularProgress size={20} /> : "XLSX herunterladen"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
